<tax-page-header titleText="kkms.kkm.disconnection-ofd-title"></tax-page-header>
<div class="ui-kit-content-container ">
  <div class="alert-box" translate>
    <svg-icon key="info"></svg-icon>sign.action.digital.signature
  </div>

  <tax-checkbox
    [id]="'rememberMe'"
    name="rememberMe"
    [(ngModel)]="isAgreement"
    labelText="kkm.action.confirmation"
  ></tax-checkbox>

  <div class="ui-kit-bottom-buttons-block">
    <button class="back-button" (click)="back()" data-qa-button="go-back" translate>group.back</button>
    <div>
      <button *ngIf="data"
        class="button_blue"
        [disabled]="!isAgreement"
        [taxOpenCertificateModal]="{ data: data }"
        (signatureGenerated)="signEds($event)"
        translate>sign.by.eds.button
      </button>
      <button
        class="button_blue"
        [disabled]="!isAgreement"
        (click)="signSms()"
        translate>sign.by.sms.button
      </button>
    </div>
  </div>
</div>

